import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { md3 } from "vuetify/blueprints";

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    blueprint: md3,

    theme: {
      defaultTheme: "light",
      themes: {
        // ─── Dark theme ───────────────────────────────────────────────
        dark: {
          colors: {
            // Brand
            primary: "#F29B14", // amber — brand + degraded warning
            "primary-darken": "#c47d0e",
            secondary: "#555555", // mid grey

            // Backgrounds
            background: "#0f1117", // near-black page background

            // Semantic — health status
            success: "#22c55e", // healthy
            warning: "#F29B14", // degraded (same as primary — intentional)
            error: "#ef4444", // unhealthy
            info: "#3b82f6", // informational

            // Text
            "on-background": "#f1f5f9",
            "on-surface": "#f1f5f9",
            "on-primary": "#0f1117",
            "on-secondary": "#ffffff",
            "on-success": "#0f1117",
            "on-warning": "#0f1117",
            "on-error": "#f1f5f9",
          },
        },

        // ─── Light theme ──────────────────────────────────────────────
        light: {
          colors: {
            // Brand
            primary: "#F29B14", // amber — brand + degraded warning
            "primary-darken": "#c47d0e",
            secondary: "#555555", // mid grey

            // Backgrounds
            background: "#fff", // warm cream page background

            // Semantic — health status
            success: "#16a34a", // healthy (darker green for light bg contrast)
            warning: "#F29B14", // degraded
            error: "#dc2626", // unhealthy (darker red for light bg contrast)
            info: "#2563eb", // informational

            // Text
            "on-background": "#1a1a1a",
            "on-surface": "#1a1a1a",
            "on-primary": "#ffffff",
            "on-secondary": "#ffffff",
            "on-success": "#ffffff",
            "on-warning": "#ffffff",
            "on-error": "#ffffff",
          },
        },
      },
    },
  });

  app.vueApp.use(vuetify);
});
